module.exports = __webpack_public_path__ + "img/logo_september_child_cancer_dark_small.fbd3928f.png";